import { render, staticRenderFns } from "./CartDeliveryAddresses.vue?vue&type=template&id=4faed9e4&scoped=true"
import script from "./CartDeliveryAddresses.vue?vue&type=script&lang=js"
export * from "./CartDeliveryAddresses.vue?vue&type=script&lang=js"
import style0 from "./CartDeliveryAddresses.vue?vue&type=style&index=0&id=4faed9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faed9e4",
  null
  
)

export default component.exports